'use strict';

angular.module('export')
    .component('exportForm', {
        templateUrl: 'modules/export/components/form/template.html',
        controller: 'ExportFormController',
    });
